module.exports = __webpack_public_path__ + "media/newstyle/images/logo-literary-highways-e66f8b973e6a4ff7d2d1d7a99bacae90.png";